import { IKnoOrganisationFunction } from 'APIPackage/AccountModule/interfaces/IKnoOrganisationFunction';

import { IKnoOrganizationFunctionSelectOption } from '../interfaces/IKnoOrganizationFunctionSelectOption';

export const createKnoOrganizationFunctionSelectOption = (
  knoOrganizationFunction: IKnoOrganisationFunction,
): IKnoOrganizationFunctionSelectOption => ({
  ...knoOrganizationFunction,
  label: `(${knoOrganizationFunction.idFrgu}) ${knoOrganizationFunction.fullName}`,
  value: knoOrganizationFunction.id,
});
